import {
  Button,
  Card,
  CardBody,
  CardHeader,
  H5,
} from "@datapay-by-datacom/design-system";
import { Link, useNavigate } from "react-router-dom";
import { OrgCategory } from "../../../generated/core-api";
import { OrgState } from "../../providers";
import { usePermissions } from "../../hooks";
import {
  IoGlobeOutline,
  IoBriefcaseOutline,
  IoPersonOutline,
} from "react-icons/io5";
import styles from "../../screens/OrgListScreen.module.css";
import { OrgCreatePersonalButton } from "./OrgCreatePersonalButton";

interface OrgCategoryListProps {
  category: OrgCategory;
  description: string;
  orgCtx: OrgState;
}

export function OrgCategoryList({
  category,
  description,
  orgCtx: { orgs, ownRoleInOrg },
}: OrgCategoryListProps) {
  const { isProvisioner } = usePermissions();
  const navigate = useNavigate();
  const canProvision = isProvisioner();
  const orgsInCategory = orgs.filter((org) => org.category === category);

  const getCategoryIcon = () => {
    switch (category) {
      case "public":
        return <IoGlobeOutline className={styles.categoryIcon} />;
      case "internal":
        return <IoBriefcaseOutline className={styles.categoryIcon} />;
      case "personal":
        return <IoPersonOutline className={styles.categoryIcon} />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.cardWrapper}>
      <Card>
        <CardHeader>
          <div className={styles.categoryHeader}>
            {getCategoryIcon()}
            <H5>{category}</H5>
            {canProvision && category !== "personal" && (
              <Button
                variant="secondary"
                size="small"
                onPress={() => navigate(`/org/create/${category}`)}
              >
                Create
              </Button>
            )}
          </div>
        </CardHeader>
        <CardBody>
          <p>{description}</p>
          <div className={styles.orgLinks}>
            {orgsInCategory.length === 0 ? (
              <>
                <i>(None)</i>{" "}
                {category === "personal" && <OrgCreatePersonalButton />}
              </>
            ) : (
              orgsInCategory.map((org) => {
                const role = ownRoleInOrg(org.id)?.role;
                return (
                  <Link to={`/org/${org.category}/${org.id}`} key={org.id}>
                    {org.name} {role && `(${role})`}
                  </Link>
                );
              })
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
